.content-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin: 20px 0;
  background-color: #f7f7f7;
  border-radius: 10px;
}
@media screen and (max-width: 500px) {
  .content-box {
    padding: 10px;
    margin: 10px 0;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvYXRvbXMiLCJzb3VyY2VzIjpbImNvbnRlbnQtYm94LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQVRKO0lBVVE7SUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi5jb250ZW50LWJveCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBwYWRkaW5nOiAyMHB4O1xuICAgIG1hcmdpbjogMjBweCAwO1xuICAgIGJhY2tncm91bmQtY29sb3I6ICNmN2Y3Zjc7XG4gICAgYm9yZGVyLXJhZGl1czogMTBweDtcblxuICAgIEBtZWRpYSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDUwMHB4KSB7XG4gICAgICAgIHBhZGRpbmc6IDEwcHg7XG4gICAgICAgIG1hcmdpbjogMTBweCAwO1xuICAgIH1cbn0iXX0= */